import React from 'react';
import './Note.css';

export const Note = ({ note }) => {
  return (
    <div className="note-container">
      <div className="note-header">
        {note.author && <div className="note-author">{note.author}</div>}
        {note.timestamp && <div className="note-date">{note.timestamp}</div>}
      </div>
      <div className="note-content">
        {note.content.split('\n').map((line, i) => (
          <p key={i}>{line}</p>
        ))}
      </div>
      {note.medium && <div className="note-medium">{note.medium}</div>}
    </div>
  );
}; 